
<template>
    <div>
        <v-alert
                :value="show"
                outlined
                transition="scale"
                :type="alertType"
                :dismissible="dismissible"
        >
            {{text}}
        </v-alert>
    </div>
</template>

<script>
    export default{
        props: ['type', 'text', 'dismissible', 'show'],
        data(){
            return {
                alertType: this.type || 'info'
            }
        }
    }
</script>
